<template>
  <div id="sitemap">
    <header>
      <InnerContent>
        <ButtonReturn to="/" colour="black" />
        <h1 class="title">Explore MS Site Map</h1>
      </InnerContent>
    </header>

    <section class="section">
      <InnerContent>
        <div class="column">
          <h2 class="home-header">
            <a
              :href="
                env === 'development'
                  ? menuItems.home.main.urlDev
                  : menuItems.home.main.urlProd
              "
              @click="logEvent('sitemap', menuItems.home.main)"
            >
              <span>Home</span>
              <img class="chevron" src="/img/icon-chevron-sitemap.svg" alt="" />
            </a>
          </h2>
          <h2 class="home-header">
            <a
              :href="
                env === 'development'
                  ? menuItems.home.glossary.urlDev
                  : menuItems.home.glossary.urlProd
              "
              @click="logEvent('sitemap', menuItems.home.glossary)"
            >
              <span>Glossary</span>
              <img class="chevron" src="/img/icon-chevron-sitemap.svg" alt="" />
            </a>
          </h2>
          <h2>
            <a
              :href="
                env === 'development'
                  ? menuItems.home.covidResources.urlDev
                  : menuItems.home.covidResources.urlProd
              "
              @click="logEvent('sitemap', menuItems.home.covidResources.title)"
            >
              <span>COVID-19</span>
              <img class="chevron" src="/img/icon-chevron-sitemap.svg" alt="" />
            </a>
          </h2>
          <ul>
            <li>
              <router-link to="covid-video1">
                COVID-19 and Disease Management – Video
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'covid-video', params: { id: 'video6' } }"
                >The Impact of COVID-19 Pandemic on Patient Care – Video
              </router-link>
            </li>
            <li>
              <router-link to="/telemedicine"
                >Telemedicine in MS – Video</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ name: 'covid-video', params: { id: 'video4' } }"
                >COVID-19, the Immune System, and Current Vaccines – Video
                Series</router-link
              >
            </li>
          </ul>

          <h2>
            <a
              :href="
                env === 'development'
                  ? menuItems.home.neuropathology.urlDev
                  : menuItems.home.neuropathology.urlProd
              "
              @click="
                logEvent(
                  'launch_menu_item',
                  menuItems.home.neuropathology.title
                )
              "
            >
              <span>Early Neuropathology</span>
              <img class="chevron" src="/img/icon-chevron-sitemap.svg" alt="" />
            </a>
          </h2>
          <ul>
            <li>
              <router-link to="ms-mod">
                Mechanism of Disease in MS – Video
              </router-link>
            </li>
            <li>
              <a href="/ms-video">
                Early Neuroinflammation and Progressive Neurodegeneration in MS
                – Video
              </a>
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.neuro[1])"
                >Pathogenic B Cells and T Cells – PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.neuro[0])"
                >Insights Into MS: Neuroinflammation and Neurodegeneration –
                PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.neuro[2])"
                >Insights Into MS: Early Pathophysiology – PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.neuro[3])"
                >Insights Into MS: Therapeutic Targets – PDF</a
              >
            </li>
          </ul>
          <h2>
            <a
              :href="
                env === 'development'
                  ? menuItems.home.recognizing.urlDev
                  : menuItems.home.recognizing.urlProd
              "
              @click="logEvent('sitemap', menuItems.home.recognizing.title)"
              >Recognizing MS<img
                class="chevron"
                src="/img/icon-chevron-sitemap.svg"
                alt=""
            /></a>
          </h2>
          <ul>
            <li>
              <router-link :to="{ name: 'treatment-initiation' }"
                >Insights Into MS: Timing of Treatment Initiation –
                Video</router-link
              >
            </li>
            <li>
              <router-link to="ms-video"
                >Diagnostic Challenges in MS – Video
              </router-link>
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.signs[0])"
                >Insights Into MS: Diagnostic Challengess – PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.signs[1])"
                >Insights Into MS: Treatment Initiation in MS – PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.signs[2])"
                >Insights Into MS: Subtle Symptoms and Disease Progression –
                PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showApp(apps.recognizing)"
                >Early MS &amp; Impact on Patient Symptoms - IA</a
              >
            </li>
          </ul>
        </div>

        <div class="column">
          <h2>
            <a
              :href="
                env === 'development'
                  ? menuItems.home.exploring.urlDev
                  : menuItems.home.exploring.urlProd
              "
              @click="logEvent('sitemap', menuItems.home.exploring.title)"
            >
              Exploring MS Over Time
              <img class="chevron" src="/img/icon-chevron-sitemap.svg" alt=""
            /></a>
          </h2>

          <ul>
            <li>
              <a href="#" @click="showApp(apps.exploring)"
                >MS Disease Progression Visualizer – Video</a
              >
            </li>
            <li>
              <router-link :to="{ name: 'treatment-strategy' }"
                >Insights Into MS: Disease Modifying Treatment Strategies –
                Video</router-link
              >
            </li>
            <!-- <li>
              <a href="#">
                Insights Into MS: Disease Modifying Treatment Strategies – PDF
              </a>
            </li> -->
            <li>
              <a href="#" @click="showApp(apps.triptych)"
                >MS Disease Progression Visualizer – IA</a
              >
            </li>
          </ul>

          <h2>
            <a
              :href="
                env === 'development'
                  ? menuItems.home.progression.urlDev
                  : menuItems.home.progression.urlProd
              "
              @click="logEvent('sitemap', menuItems.home.progression.title)"
            >
              Patient Impact of MS Progression
              <img class="chevron" src="/img/icon-chevron-sitemap.svg" alt=""
            /></a>
          </h2>
          <ul>
            <li>
              <a href="#" @click="showPdf(pdfs.progression[0])"
                >Insights Into MS: Patient Views on Disease Progression – PDF
              </a>
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.progression[1])"
                >Insights Into MS: Cognitive Impairment – PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showApp(apps.progression)"
                >Explore the Progression of MS Through Patient Journeys – IA</a
              >
            </li>
          </ul>

          <h2>
            <a
              :href="
                env === 'development'
                  ? menuItems.home.care.urlDev
                  : menuItems.home.care.urlProd
              "
              @click="logEvent('sitemap', menuItems.home.care.title)"
            >
              The Spectrum of Patient Care
              <img class="chevron" src="/img/icon-chevron-sitemap.svg" alt=""
            /></a>
          </h2>
          <ul>
            <li>
              <router-link :to="{ name: 'immunoglobulins' }"
                >Immunoglobulins and MS - Video</router-link
              >
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.care[2])"
                >Insights Into MS: The Role of Immunoglobulins – PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.care[0])"
                >Insights Into MS: Nonpharmacological Patient Care – PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showPdf(pdfs.care[1])"
                >Insights Into MS: Empowering Patients – PDF</a
              >
            </li>
            <li>
              <a href="#" @click="showApp(apps.care)"
                >Patient Perspectives on Unmet Needs – IA</a
              >
            </li>
          </ul>
        </div>
      </InnerContent>
    </section>
    <footer>
      <InnerContent> </InnerContent>
    </footer>
  </div>
</template>

<script>
import ButtonReturn from "@/components/ButtonReturn.vue";

import { menuItems } from "@/assets/menuItems.js";
export default {
  name: "Sitemap",
  components: {
    ButtonReturn,
  },
  data() {
    return {
      menuItems: menuItems,
      apps: {
        recognizing: {
          urlDev: "http://dev.invivo.ca/novartis/ms-interactive-model/",
          urlProd: "/early-symptoms",
          analyticsLabel:
            "Sitemap: Early Multiple Sclerosis & Impact on Patient Symptoms",
        },
        exploring: {
          urlDev: "http://dev.invivo.ca/novartis/ms-triptych-video/",
          urlProd: "/progression/visualizer/video",
          analyticsLabel:
            "Sitemap: Multiple Sclerosis Disease Progression Visualizer",
        },
        triptych: {
          urlDev: "http://dev.invivo.ca/novartis/ms-triptych-web/",
          urlProd: "/progression/visualizer",
          analyticsLabel: "Sitemap: Disease progression visualizer app",
        },
        progression: {
          urlDev: "http://dev.invivo.ca/novartis/ms-patient-journey-explorer/",
          urlProd: "/progression/patient-journeys",
          analyticsLabel: "Sitemap: Clinical presentations",
        },
        care: {
          urlDev: "http://dev.invivo.ca/novartis/ms-mosaic-wall-quiz/",
          urlProd: "/patient-centered-care/unmet-needs",
          analyticsLabel: "Sitemap: Unmet needs",
        },
      },
      audio: {
        covid: [
          {
            id: "covid-audio2",
            title: "Telemedicine in MS",
            src: "assets/audio/telemedicine.mp3",
            analyticsLabel: "Sitemap: Telemedicine in MS",
          },
        ],
        signs: [
          {
            id: "signs-audio1",
            title: "Early MS and impact on patient symptoms",
            src: "assets/audio/earlyms.mp3",
            analyticsLabel: "Sitemap: Early MS and impact on patient symptoms",
          },
        ],
        progression: [
          {
            id: "progression-audio1",
            title: "MS Disease Progression Audio",
            src: "assets/audio/msdiseaseprogression.mp3",
            analyticsLabel: "Sitemap: MS Disease Progression Audio",
          },
        ],
        recognizing: [
          {
            id: "recognizing-audio1",
            title: "Early MS & Impact on Patient Symptoms Audio",
            src: "assets/audio/earlyMS_and_impact.mp3",
            analyticsLabel:
              "Sitemap: Early MS & Impact on Patient Symptoms Audio",
          },
        ],
      },
      pdfs: {
        covid: [
          {
            src: "covid.pdf",
            analyticsLabel: "COVID-19: COVID and MS",
          },
        ],
        neuro: [
          {
            src: "pathogenic-b-t-cells.pdf",
            analyticsLabel: "Sitemap: Pathogenic B Cells and T Cells",
          },
          {
            src: "neuroinflammation.pdf",
            analyticsLabel: "Sitemap: Neuroinflammation",
          },
          {
            src: "early-pathophysiology.pdf",
            analyticsLabel: "Sitemap: Pathophysiology",
          },
          {
            src: "current-therapeutic-targets.pdf",
            analyticsLabel: "Sitemap: Current research therapeutic targets",
          },
        ],
        signs: [
          {
            src: "diagnostic-challenges.pdf",
            analyticsLabel: "Sitemap: Diagnostic challenges",
          },
          {
            src: "early-treatment.pdf",
            analyticsLabel: "Sitemap: Early treatment",
          },
          {
            src: "subtle-symptoms-and-disease-progression.pdf",
            analyticsLabel:
              "Sitemap: Clinical expression in early neuropathology",
          },
        ],
        progression: [
          {
            src: "patient-views-on-disease-progression.pdf",
            analyticsLabel: "Sitemap: Patient views on MS progression",
          },
          {
            src: "cognitive-impairment.pdf",
            analyticsLabel: "Sitemap: Cognitive impairment",
          },
        ],
        care: [
          {
            src: "holistic-treatment.pdf",
            analyticsLabel: "Sitemap: Holistic treatment",
          },
          {
            src: "empowering-patients.pdf",
            analyticsLabel: "Sitemap: Empowering patients",
          },
          {
            src: "immunoglobulin.pdf",
            analyticsLabel: "Sitemap: Immunoglobulins in MS",
          },
        ],
      },
    };
  },
  computed: {
    env() {
      return process.env.NODE_ENV;
    },
  },
  methods: {
    showApp: function(app) {
      this.$gtag.event("click", {
        event_category: "launch_page",
        event_label: app.analyticsLabel,
      });

      let url =
        process.env.NODE_ENV === "development" ? app.urlDev : app.urlProd;

      window.open(url, "_self");
    },
    showPdf: function(data) {
      window.open(`./pdf/${data.src}`);

      this.$gtag.event("click", {
        event_category: "view_pdf",
        event_label: `${data.analyticsLabel}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/styles";

#resources {
  width: 100%;
  position: relative;
}

.page {
  background: $white;
}

::v-deep .inner-content {
  margin: 0 auto;
}

::v-deep .button-return-icon {
  display: inline-block;
  width: 35px;
  margin-right: 15px;
}

::v-deep .button-return {
  float: right;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  background: transparent;
  border: none;
  font-size: 1rem;
  color: #000;
  font-weight: 700;
}

.title {
  font-size: rem(46px);
  color: $blue;
  margin: rem(60px) 0 rem(20px) 0;

  @include breakpoint(xs) {
    font-size: rem(24px);
    line-height: rem(24px);
    margin: rem(20px) 0;
  }

  @include breakpoint(md) {
    font-size: rem(36px);
    line-height: rem(40px);
  }
}

.intro-copy {
  width: 80%;
  font-size: rem(24px);
  line-height: rem(32px);
  margin-bottom: rem(20px);

  @include breakpoint(md) {
    width: 100%;
    font-size: rem(18px);
    line-height: rem(22px);
  }

  @include breakpoint(xs) {
    width: 100%;
    font-size: rem(16px);
    line-height: rem(22px);
    margin-bottom: 20px;
  }
}

.section {
  background: $grey;
  padding: rem(30px);
  margin-bottom: rem(15px);

  .inner-content {
    display: flex;
    flex-direction: row;

    @media screen and (max-width: 414px) {
      flex-direction: column;
    }
  }

  h2 {
    font-size: rem(22px);

    &.home-header {
      margin-bottom: 40px;
    }

    a {
      display: flex;
      align-items: center;
    }

    .chevron {
      margin-left: 10px;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin-bottom: 40px;

    li {
      font-size: rem(14px);
      margin: 10px 0;
    }
  }

  ::v-deep .audio-element-container {
    width: 75%;
  }
}

.section-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.column {
  width: 50%;
  padding-right: 20px;

  @media screen and (max-width: 414px) {
    padding-right: 0;
  }
}

.link {
  border: none;
  background: none;
  color: $black;
  display: flex;
  align-items: center;
  text-align: left;
  padding-left: 0;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}

.resources {
  margin-bottom: rem(30px);
}

.resources-list {
  padding-left: 0;
  list-style-type: none;
  margin: 0;

  li {
    margin-bottom: rem(20px);
  }
}

a {
  color: $black;
  &:hover {
    text-decoration: none;
  }
}

.inner-wrapper {
  padding-bottom: rem(60px);
  background: linear-gradient(180deg, $grey 0%, $white 25%);
  position: relative;
}

@media (max-width: 1023px) {
}

@media screen and (max-width: 767px) {
  .section-container {
    display: block;
  }

  .section {
    padding-left: 0;
    padding-right: 0;
  }

  .img-container,
  .column {
    width: 100%;
  }

  .img-container {
    margin-bottom: rem(20px);
  }
}
</style>
